import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom-v5-compat';

import { getInventorySyncSettingsPagePath } from '../../../../../routes/constants';
import { useProductDetailsContext } from '../../../use-product-details-context';
import { ProductInventorySyncPanel } from './product-inventory-sync-panel';

export const ProductDetailsInventorySyncV3 = () => {
  const navigate = useNavigate();
  const { productSku, closeModal } = useProductDetailsContext();

  const handleEditConfigurationClick = useCallback(() => {
    closeModal();
    navigate(getInventorySyncSettingsPagePath());
  }, [closeModal, navigate]);

  return <ProductInventorySyncPanel onEditConfigurationClick={handleEditConfigurationClick} productSku={productSku} />;
};
